import { cn } from "@/lib/utils";
import { formatString } from "@/lib/utils/ui";
import { Dispatch, FC, SetStateAction } from "react";

type NavigatorProps = {
  navigationKeys: string[];
  activeKey: string;
  setActiveKey: Dispatch<SetStateAction<string>>;
  isAllEventPullCommand?: boolean;
};

const Navigator: FC<NavigatorProps> = ({
  navigationKeys,
  setActiveKey,
  activeKey,
  isAllEventPullCommand
}) => {
  const eventsCodeAndBucketNameMapping = new Map([
    ["CEFV", "Current Related Events : [0.0.96.11.1.255]"],
    ["VEFV", "Voltage Related Events: [0.0.96.11.0.255]"],
    ["PEFV", "Power Related Events :[0.0.96.11.2.255]"],
    ["TEFV", "Transaction Related Events: [0.0.96.11.3.255]"],
    ["OEFV", "Other Events: [0.0.96.11.4.255]"],
    ["NREFV", "Non-Rollover Events: [0.0.96.11.5.255]"],
    ["DEFV", "Control Related Events: [0.0.96.11.6.255]"]
  ]);

  const keysToFilter = ["data_type", "day_id_active"];
  if (!navigationKeys || navigationKeys.length === 0) {
    return (
      <div className="flex justify-center text-[#0A3690] bg-[#EFF1FF] text-sm rounded-md p-5 h-[350px] items-center">
        No results.
      </div>
    );
  }
  return (
    <div className="font-bold bg-[#EFF1FF] text-sm rounded-md p-5 h-[350px] overflow-y-auto">
      {navigationKeys
        .filter((e) => !keysToFilter.includes(e))
        .map((e, i) => {
          return (
            <div
              key={i}
              className={cn(
                "cursor-pointer text-[#7C818C]",
                activeKey === e && "text-[#004FFF]"
              )}
              onClick={() => setActiveKey(e)}
            >
              {isAllEventPullCommand ? (
                <div>
                  {eventsCodeAndBucketNameMapping.get(e)?.split(":")[0]}
                  <br />
                  {eventsCodeAndBucketNameMapping.get(e)?.split(":")[1]}
                </div>
              ) : (
                formatString(e)
              )}
            </div>
          );
        })}
    </div>
  );
};

export default Navigator;
